import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Update } from '@ngrx/entity';
import { ProductOrganisationId, PromotionDetail, PromotionId } from '@portal-front-end/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_SERVER_TOKEN } from '../api-server-token';

@Injectable({ providedIn: 'root' })

export class PromotionDetailApiService {

    constructor(
        private readonly http: HttpClient,
        @Inject(API_SERVER_TOKEN) private apiServer: string
    ) { }

    private readonly PROMOTION_DETAIL_URL = `${this.apiServer}/promotion-details`;

    getPromotionDetails(promotionId: PromotionId): Observable<PromotionDetail[]> {
        return this.http.get<PromotionDetail[]>(`${this.PROMOTION_DETAIL_URL}`,{
            params: { 'promotionId' : promotionId }
        });
    }

    updatePromotionDetail(object: Update<PromotionDetail>): Observable<PromotionDetail> {
        return this.http.put<PromotionDetail>(`${this.PROMOTION_DETAIL_URL}/${object.changes.promotionDetailId}`, object.changes);
    }

    deletePromotionDetail(id: string | number) {
        return this.http.delete<string | number>(`${this.PROMOTION_DETAIL_URL}/${id}`)
            .pipe(map(() => id));
    }

    insertPromotionDetails(object: PromotionDetail): Observable<PromotionDetail> {
        return this.http.post<PromotionDetail>(`${this.PROMOTION_DETAIL_URL}`, object, {
            params: { 'promotionId' : object.promotionId }
        });
    }

    getPromotionDetailsByProdOrgId(productOrganisationId: ProductOrganisationId): Observable<PromotionDetail[]> {
        return this.http.get<PromotionDetail[]>(`${this.PROMOTION_DETAIL_URL}/${productOrganisationId}`);
    } 
}
